import { ThirdPartyEvaluationStatus } from './thirdparty-evaluation-status'
import { ThirdPartyEvaluationForm } from './thirdparty-evaluation-form';

export class ThirdPartyEvaluationExplore {
    evaluationState: ThirdPartyEvaluationStatus;
    formDto: ThirdPartyEvaluationForm;

    constructor() {
        this.evaluationState = new ThirdPartyEvaluationStatus();
        this.formDto = new ThirdPartyEvaluationForm();      
    }
}